import { InfoCircleOutlined, PaperClipOutlined } from '@ant-design/icons'
import { useGetOboDetails } from '@Admin/AdminQuotingPage/components/PartDFMReportPanel/logic'
import { useNavigate } from 'react-router-dom'

import Box from '~/core/Box'
import Link from '~/core/Link'
import Popover from '~/core/Popover'
import Text from '~/core/Text'
import TruncatedText from '~/core/TruncatedText'
import getColor from '~/lib/getColor'
import {
    BLACK_ALPHA_BOTTOM,
    MANUFACTURING_DRAWING_CONTENT,
    PURCHASE_DRAWING_CONTENT,
    MANUFACTURING_DRAWING_CONTENT_TITLE,
    PURCHASE_DRAWING_CONTENT_TITLE,
    MANUFACTURING_DRAWING,
    PURCHASE_DRAWING,
    NO_INSPECTON_DRAWNG,
    MAX_LENGTH_FILENAME,
    DFM_FEEDBACK_KEY,
    handleUrl,
    INSPECTION_KEY,
    TRACK_SHIPMENT_KEY,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { PartDetailsType } from '~/apps/consumer/components/PartViewerModal/types'
import SafeDownloadLink from '~/apps/consumer/components/SafeDownloadLink'
import PartAttributes from '~/apps/consumer/components/PartViewerModal/components/PartDetails/components/PartAttributes'
import ThreadsConfiguredCard from '~/apps/consumer/components/PartViewerModal/components/PartDetails/components/PartAttributes/components/ThreadsConfiguredCard'
import { ADMIN_PATH, ORDERS_PATH } from '~/redux-modules/preferences'
import { MANUFACTURABILITY_FEEDBACK_TAB } from '~/apps/consumer/pages/Orders/constants'

export default function PartDetails(props: PartDetailsType) {
    const {
        quantity,
        inspectionDocumentsLength,
        tapsCount,
        holesCount,
        dfmFeedback,
        processName,
        materialName,
        twoDdrawing,
        processes,
        placement,
        setActivePage,
        isInspectionReportEnabled,
        shouldShowThreadTag,
        material,
        isImOrder,
        dfmReportsLength,
        isSalesOrderLine,
        orderName,
        qmrId,
        quoteOwnerId,
        activePage,
        shipmentDetails,
        onClose,
        setSelectedTab,
    } = props

    const dfmFeedbackCount = dfmFeedback?.length || 0
    const isEnabledForIm = isImOrder && isSalesOrderLine
    const manufacturingDrawing = twoDdrawing?.sanitized
    const purchasedDrawing = twoDdrawing?.annotated
    const { isObo, oboUserId } = useGetOboDetails(quoteOwnerId || '')
    const seeDfmFeedbackUrl = isObo
        ? `${ADMIN_PATH}/user/${oboUserId}${ORDERS_PATH}/${orderName}#${MANUFACTURABILITY_FEEDBACK_TAB}`
        : `${ORDERS_PATH}/${orderName}#${MANUFACTURABILITY_FEEDBACK_TAB}`

    const seeDfmReportsUrl = isObo
        ? `${ADMIN_PATH}/user/${oboUserId}${ORDERS_PATH}/${orderName}/part/${qmrId}/${DFM_FEEDBACK_KEY}`
        : `${ORDERS_PATH}/${orderName}/part/${qmrId}/${DFM_FEEDBACK_KEY}`

    let manufacturingDrawingFileName = manufacturingDrawing?.fileName

    if (
        manufacturingDrawingFileName &&
        !manufacturingDrawingFileName.includes('.pdf')
    ) {
        manufacturingDrawingFileName = `${manufacturingDrawing?.fileName}.pdf`
    }
    const shouldShowShipments = Boolean(shipmentDetails?.length)

    const hasMultipleShipments = shipmentDetails && shipmentDetails.length > 1

    const viewShipment = hasMultipleShipments
        ? 'View shipments'
        : 'View shipment'
    const shipments = hasMultipleShipments ? 'shipments' : 'shipment'

    const drawingIcon = (
        <InfoCircleOutlined
            style={{
                color: getColor('shroudBlue'),
                marginLeft: '5px',
                marginTop: '12px',
            }}
        />
    )

    const navigate = useNavigate()
    const viewDfmReportsAndFeedback = (evt: any) => {
        evt.preventDefault()
        evt.stopPropagation()
        if (dfmFeedbackCount) {
            if (onClose) {
                onClose(evt)
            }
            navigate(seeDfmFeedbackUrl, { replace: true })
            if (setSelectedTab) {
                setSelectedTab(MANUFACTURABILITY_FEEDBACK_TAB)
            }
        } else {
            navigate(seeDfmReportsUrl, { replace: true })
        }
    }

    return (
        <>
            {processName && quantity && materialName ? (
                <PartAttributes
                    quantity={quantity}
                    processName={processName}
                    materialName={materialName}
                    processes={processes || []}
                    material={material}
                    isImOrder={isImOrder}
                />
            ) : null}
            {purchasedDrawing ? (
                <>
                    <Text
                        fontSize="14px"
                        color={getColor('black')}
                        fontWeight={400}
                        style={{ marginTop: '5px', marginLeft: '2px' }}
                    >
                        {PURCHASE_DRAWING}
                        <Popover
                            content={
                                <Text fontWeight={300} fontSize="14px">
                                    {PURCHASE_DRAWING_CONTENT}
                                </Text>
                            }
                            title={
                                <Text fontSize="14px" fontWeight="normal">
                                    {PURCHASE_DRAWING_CONTENT_TITLE}
                                </Text>
                            }
                            placement="top"
                            overlayStyle={{
                                width: '304px',
                            }}
                        >
                            {drawingIcon}
                        </Popover>
                    </Text>
                    <SafeDownloadLink
                        name="view-purchasing-attachment"
                        placement={placement}
                        downloadUrl={purchasedDrawing?.downloadUrl}
                        style={{ marginTop: '5px', marginLeft: '2px' }}
                    >
                        <PaperClipOutlined
                            style={{
                                color: getColor('shroudBlue'),
                                marginRight: '5px',
                            }}
                        />
                        <Text color={getColor('shroudBlue')}>
                            <TruncatedText maxLength={MAX_LENGTH_FILENAME}>
                                {purchasedDrawing?.fileName}
                            </TruncatedText>
                        </Text>
                    </SafeDownloadLink>
                </>
            ) : null}
            <Box alignItems="center">
                <Text
                    fontSize="14px"
                    fontWeight={400}
                    color={getColor('black')}
                    style={{ marginTop: '16px', marginLeft: '2px' }}
                >
                    {MANUFACTURING_DRAWING}
                </Text>
                <Popover
                    content={
                        <Text fontSize="14px" fontWeight={300}>
                            {MANUFACTURING_DRAWING_CONTENT}
                        </Text>
                    }
                    title={
                        <Text fontSize="14px" fontWeight="normal">
                            {MANUFACTURING_DRAWING_CONTENT_TITLE}
                        </Text>
                    }
                    placement="top"
                    overlayStyle={{
                        width: '304px',
                        marginLeft: '25px',
                    }}
                >
                    {drawingIcon}
                </Popover>
            </Box>
            <Box
                borderBottom={BLACK_ALPHA_BOTTOM}
                padding="0 0 16px"
                justifyContent="between"
            >
                {!manufacturingDrawing ? (
                    <Text
                        color={getColor('blackAlpha45')}
                        style={{ marginTop: '4px', marginLeft: '2px' }}
                    >
                        {NO_INSPECTON_DRAWNG}
                    </Text>
                ) : (
                    <SafeDownloadLink
                        name="view-manufacturing-attachment"
                        placement={placement}
                        downloadUrl={manufacturingDrawing?.downloadUrl}
                        style={{ marginTop: '5px', marginLeft: '2px' }}
                    >
                        <PaperClipOutlined
                            style={{
                                color: getColor('shroudBlue'),
                                marginRight: '5px',
                            }}
                        />
                        <Text color={getColor('shroudBlue')}>
                            <TruncatedText maxLength={MAX_LENGTH_FILENAME}>
                                {manufacturingDrawingFileName}
                            </TruncatedText>
                        </Text>
                    </SafeDownloadLink>
                )}
            </Box>
            {shouldShowThreadTag && !!holesCount && holesCount > 0 && (
                <ThreadsConfiguredCard
                    holesCount={holesCount}
                    tapsCount={tapsCount}
                    placement={placement}
                    setActivePage={setActivePage}
                    activePage={activePage}
                />
            )}
            {!isImOrder && (
                <Box
                    borderBottom={BLACK_ALPHA_BOTTOM}
                    padding="16px 0 16px"
                    justifyContent="between"
                >
                    {dfmFeedbackCount > 0 ? (
                        <>
                            <Box>
                                <Text color="success" fontSize="14px">
                                    {dfmFeedbackCount} manufacturability
                                    warnings
                                </Text>
                            </Box>
                            <Box>
                                <Link
                                    name="view feedback"
                                    placement={placement}
                                    onClick={(evt: Event) => {
                                        evt.preventDefault()
                                        setActivePage(DFM_FEEDBACK_KEY)
                                        handleUrl(
                                            DFM_FEEDBACK_KEY,
                                            activePage,
                                            navigate,
                                        )
                                    }}
                                >
                                    View feedback
                                </Link>
                            </Box>
                        </>
                    ) : (
                        <Text fontSize="14px" color="success">
                            No manufacturability warnings
                        </Text>
                    )}
                </Box>
            )}
            {isEnabledForIm ? (
                <Box
                    padding="16px 0 16px"
                    borderBottom={BLACK_ALPHA_BOTTOM}
                    justifyContent="between"
                >
                    <Box>
                        <Text fontSize="14px" color="black" fontWeight={400}>
                            Manufacturability feedback
                        </Text>
                    </Box>
                    {dfmReportsLength || dfmFeedbackCount > 0 ? (
                        <Box>
                            <Link
                                name="view DFM report"
                                placement={placement}
                                onClick={viewDfmReportsAndFeedback}
                            >
                                View Feedback
                            </Link>
                        </Box>
                    ) : (
                        <Box>Not available</Box>
                    )}
                </Box>
            ) : null}
            {isInspectionReportEnabled ? (
                <Box
                    padding="16px 0 16px"
                    justifyContent="between"
                    borderBottom={BLACK_ALPHA_BOTTOM}
                >
                    <Box>
                        <Text fontSize="14px" color="black" fontWeight={400}>
                            Inspection report
                        </Text>
                    </Box>
                    {inspectionDocumentsLength > 0 ? (
                        <Box>
                            <Link
                                name="view inspection"
                                placement={placement}
                                onClick={(evt: Event) => {
                                    evt.preventDefault()
                                    setActivePage(INSPECTION_KEY)
                                    handleUrl(
                                        INSPECTION_KEY,
                                        activePage,
                                        navigate,
                                    )
                                }}
                            >
                                View inspection
                            </Link>
                        </Box>
                    ) : (
                        <Box>Not available</Box>
                    )}
                </Box>
            ) : null}
            {shouldShowShipments && (
                <>
                    <Box marginTop="16px">
                        <Text
                            fontSize="14px"
                            color="blackAlpha85"
                            fontWeight={400}
                        >
                            Shipments
                        </Text>{' '}
                    </Box>
                    <Box
                        padding="4px 0 16px"
                        justifyContent="between"
                        borderBottom={BLACK_ALPHA_BOTTOM}
                    >
                        <Text
                            style={{
                                flex: 'none',
                                order: 0,
                                flexGrow: 0,
                                margin: 0,
                                color: 'blackAlpha65',
                                width: '79px',
                                height: '22px',
                                left: 0,
                                top: 0,
                            }}
                        >
                            {shipmentDetails?.length} {shipments}
                        </Text>
                        <Box>
                            <Link
                                name="view-shipments"
                                placement={placement}
                                onClick={(evt: Event) => {
                                    evt.preventDefault()
                                    setActivePage(TRACK_SHIPMENT_KEY)
                                    handleUrl(
                                        TRACK_SHIPMENT_KEY,
                                        activePage,
                                        navigate,
                                    )
                                }}
                            >
                                {viewShipment}
                            </Link>
                        </Box>
                    </Box>
                </>
            )}
        </>
    )
}
